import { Component } from '@angular/core';

@Component({
	selector: 'app-spur-trust-bar',
	standalone: true,
	templateUrl: './spur-trust-bar.component.html',
	styleUrls: ['./spur-trust-bar.component.css']
})
export class SpurTrustBarComponent {
	readonly features = [
		{
			title: 'Cash Back',
			description: 'To purchaser for 30 days from order.',
			icon: 'cash'
		},
		{
			title: 'Flexible Swaps',
			description: 'Swap one experience for another.',
			icon: 'swap'
		},
		{
			title: 'Never Expire',
			description: 'Vouchers never expire.',
			icon: 'calendar'
		},
		{
			title: 'Gifting Options',
			description: 'Purchase an E-gift or gift box.',
			icon: 'gift'
		}
	];
}
